import {NgModule} from '@angular/core';
import {ClickOutsideDirective} from './click-outside.directive';
import { DndDirective } from './dnd.directive';
import { PlainPasteDirective } from './plain-paste.directive';
import {DisableNumberInputScrollDirective} from './disable-number-input-scroll.directive';
import { FadeInDirective } from './fade-in.directive';


@NgModule({
  declarations: [ClickOutsideDirective, DndDirective, DisableNumberInputScrollDirective, PlainPasteDirective, FadeInDirective],
  exports: [ClickOutsideDirective, DndDirective, DisableNumberInputScrollDirective, PlainPasteDirective, FadeInDirective],
})
export class DirectivesModule {}
